import {ModalTiteledWindow} from "./modalWindow.js";

export class ModalShowInfo extends ModalTiteledWindow {

   constructor(title, body, cssClass) {
      super();
      this.load(title, body);
      this.panel.classList.add('modal-show-info');
      if (cssClass) this.panel.classList.add(cssClass);
   }

   load(title, body) {
      this.setTitle(title);
      const elContainer = (typeof body === 'string') ? HTMLElement.createFromHTML(body) : body;
      this.appendToBody(elContainer);
      setTimeout(() => this.show(), 1);
   }

}
